/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontContactButton_seller = {
    readonly serviceId: string | null;
    readonly " $refType": "StorefrontContactButton_seller";
};
export type StorefrontContactButton_seller$data = StorefrontContactButton_seller;
export type StorefrontContactButton_seller$key = {
    readonly " $data"?: StorefrontContactButton_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontContactButton_seller">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontContactButton_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = 'e40e078ed7e25c3329a991d14ec00f41';
export default node;
